import React from 'react';
import './ContentPanel.css';

/**
 * ContentPanel Component
 * Content panel for displaying feature details in interactive sections
 * 
 * @param {object} content - Content object with {title, subtitle, sections: [{title, items: []}]}
 * @param {string} className - Additional CSS classes
 */
const ContentPanel = ({ content, className = '' }) => {
  if (!content) return null;

  return (
    <div className={`content-panel ${className}`}>
      <div className="content-section active">
        {content.title && (
          <h3>{content.title}</h3>
        )}
        {content.subtitle && (
          <p>{content.subtitle}</p>
        )}
        {content.sections && content.sections.length > 0 && (
          <div className="feature-details">
            {content.sections.map((section, index) => (
              <div key={index} className="feature-row">
                {section.title && (
                  <h4>{section.title}</h4>
                )}
                {section.items && section.items.length > 0 && (
                  <ul>
                    {section.items.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentPanel;























